import React, { useState } from "react";
import "../../App.css";
import { Gamepad2, ChevronRight, CalendarPlus, ChartNoAxesCombined } from "lucide-react";
import { SidebarMenuItem, SidebarMenuButton, SidebarMenuSub, SidebarMenuSubButton, SidebarMenuSubItem } from "../ui/sidebar";
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from "../../components/ui/collapsible";

const LinkDrop = ({ Icon, pageKey, page, currentPageKey }) => {
  const [isOpen, setIsOpen] = useState(false);
  const subpages = page.subpages;

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen} key={page} asChildclassName={"group/collapsible"}>
      <SidebarMenuItem>
        <CollapsibleTrigger asChild>
          <SidebarMenuButton className={"text-black justify-apart"}>
            {Icon ? <img src={Icon} alt={`${pageKey} icon`} className="size-5" /> : <Gamepad2 className="size-6 stroke-black dark:stroke-white " />}
            <span className="text-[var(--text-dark)] dark:text-[var(--text-light)] "> {pageKey} </span>
            {subpages && <ChevronRight className={` stroke-[var(--text-dark)] dark:stroke-[var(--text-light)] ml-auto size-4 transition-transform ${isOpen ? "rotate-90" : ""}`} />}
          </SidebarMenuButton>
        </CollapsibleTrigger>
        {subpages && (
          <CollapsibleContent>
            <SidebarMenuSub>
              <SidebarMenuSubItem>
                <SidebarMenuSubButton asChild>
                  <a href={`/${currentPageKey}`} className="appearance-none no-underline">
                    <CalendarPlus className="size-3" />
                    <span className={"text-sm"}> Planning </span>
                  </a>
                </SidebarMenuSubButton>
              </SidebarMenuSubItem>
              {Object.entries(subpages).map(([subpageKey]) => (
                <SidebarMenuSubItem key={subpageKey}>
                  <SidebarMenuSubButton asChild>
                    <a href={`/${currentPageKey}/${subpageKey}`} className={"appearance-none no-underline"}>
                      <ChartNoAxesCombined />
                      <span> {subpageKey} </span>
                    </a>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>
              ))}
            </SidebarMenuSub>
          </CollapsibleContent>
        )}
      </SidebarMenuItem>
    </Collapsible>
  );
};

export default LinkDrop;
